import React, { useEffect, useState } from 'react';
import logo from '../../../assets/website/images/logo.png';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CMSOptions } from '../services/website.services';
import { MENU_LOCATION } from '../../../utils/Constants';

function WebsiteHeader() {
  const { t } = useTranslation();
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const isActive = (url = "/") => {
    if (url === '/') {
      // Only return true for exact home path match
      return window?.location?.pathname === '/';
    }
    return window?.location?.pathname?.includes(url);
  }

  useEffect(() => {
    CMSOptions(MENU_LOCATION.menu_of_page_header).then((response) => {
      setDynamicOptions(response?.data || []);
    }).catch((error) => {
      console.log("error of terms&conditions", error);
    });
  }, []);

  return (
    <div className='header-marketing'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container">
          <a className="navbar-brand" href="#"><img src={logo} alt="Pouring coffee" className="img-fluid" /></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav m-auto gap-3">

              <li className="nav-item">
                <NavLink end={true} to='/' className={isActive('/') ? "nav-link active" : "nav-link "}>{t("website.header.web_nav_link_home")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink end={true} to='/about-us' className={isActive('/about-us') ? "nav-link active" : "nav-link "}>{t("website.header.web_nav_link_about_us")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to='/contact-us' className={isActive('/contact-us') ? "nav-link active" : "nav-link "}>{t("website.header.web_nav_link_contact_us")}</NavLink>
              </li>
              <li className="nav-item">
                <Link to='/#how-it-work' className={"nav-link "}>{t("website.header.web_how_does_it_work_heading")}</Link>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="#">{t("website.header.web_nav_link_pricing")}</a>
              </li> */}
              <li className="nav-item">
                <NavLink end={true} to='/faq' className={isActive('/faq') ? "nav-link active" : "nav-link "}>{t("website.header.web_nav_link_faq")}</NavLink>
              </li>
              {/* <li class="nav-item">
                  <NavLink end to='/privacy-policy' className={isActive('/privacy-policy') ? "nav-link active" : "nav-link "}>{t("website.header.web_nav_link_privacy")}</NavLink>
                </li> */}
              {
                dynamicOptions?.map((item, i) => {
                    return (
                      <li key={i}>
                        <NavLink end={true} to={`/org-info/${item?.slug}`} className={isActive(`/${item?.slug}`) ? "nav-link active" : "nav-link "}>{item?.title}</NavLink>
                      </li>
                    )
                  })
              }
            </ul>
            <Link className='btn btn-primary' end={true} to={`/inquiry`} >{t("website.header.web_nav_link_inquire_now")}</Link>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default WebsiteHeader;